import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useImperativeHandle, useRef } from "react";
import { useCombineRefs } from "../../hooks/useCombineRefs";
import { useFocusList } from "./useFocusList";
import * as Styled from "./FocusList.styled";
export const FocusList = forwardRef((props, ref) => {
    const { children, itemSelector = "button:enabled,a,[tabindex]", groupingSelector, keyboardDirection, keyboardEventMustMatchItemSelector, shouldAutoFocus, preventScrollOnAutoFocus, shouldFocusMatchOnType, shouldCirculate, focusManagementStrategy, elementType, onItemFocus, ...otherProps } = props;
    const listRef = useRef(null);
    const { handleListKeyDown, handleListItemFocus, focusFirst } = useFocusList({
        listRef,
        itemSelector,
        groupingSelector,
        keyboardDirection,
        keyboardEventMustMatchItemSelector,
        shouldAutoFocus,
        preventScrollOnAutoFocus,
        shouldFocusMatchOnType,
        shouldCirculate,
        focusManagementStrategy,
        onItemFocus
    });
    useImperativeHandle(ref, () => {
        if (!listRef.current) {
            return null;
        }
        // Run focusFirst logic if ref.current.focus() is called. Used by SlateRTE.
        return Object.assign(listRef.current, { focus: focusFirst });
    });
    return (_jsx(Styled.FocusList, { ref: useCombineRefs(listRef, ref), onKeyDown: handleListKeyDown, onFocus: handleListItemFocus, "data-testid": "FocusList", as: elementType, ...otherProps, children: children }));
});
FocusList.displayName = "FocusList";
